"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The MeterChart component is used to show high/low statistic data
 */
const MeterChart = /*#__PURE__*/React.forwardRef(({
  leftLabel,
  leftValue,
  rightLabel,
  rightValue,
  description,
  min = 0,
  max = 100,
  value,
  variant = 'static1',
  ...otherProps
}, ref) => (0, _pragma.createFelaElement)(_.View, _extends({
  flexDirection: "column",
  flex: true,
  gap: "medium",
  ref: ref
}, otherProps), (0, _pragma.createFelaElement)(_.Progress, {
  max: max,
  min: min,
  value: value,
  variant: variant
}), (0, _pragma.createFelaElement)(_.View, {
  flex: true,
  justifyContent: "space-between"
}, (0, _pragma.createFelaElement)(_.View, {
  gap: "xsmall"
}, leftValue && (0, _pragma.createFelaElement)(_.Text, {
  children: leftValue,
  color: "text.1",
  variant: variant === 'buySell' ? 'metaBold' : 'meta'
}), leftLabel && (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta"
}, "(".concat(leftLabel, ")"))), description && (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta"
}, description), (0, _pragma.createFelaElement)(_.View, {
  gap: "xsmall"
}, rightLabel && (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta"
}, "(".concat(rightLabel, ")")), rightValue && (0, _pragma.createFelaElement)(_.Text, {
  children: rightValue,
  color: "text.1",
  variant: variant === 'buySell' ? 'metaBold' : 'meta'
})))));
MeterChart.displayName = 'MeterChart';
var _default = MeterChart;
exports.default = _default;
//# sourceMappingURL=MeterChart.js.map